var map = {
	"./partners1.png": "05aa",
	"./partners10.png": "376b",
	"./partners11.png": "d46e",
	"./partners12.png": "e4a4",
	"./partners13.png": "a0d0",
	"./partners14.png": "6ac8",
	"./partners15.png": "6e70",
	"./partners16.png": "9a9f",
	"./partners17.png": "4f24",
	"./partners18.png": "0f37",
	"./partners2.png": "40f4",
	"./partners3.png": "7f20",
	"./partners4.png": "8965",
	"./partners5.png": "b7f7",
	"./partners6.png": "844e",
	"./partners7.png": "1cc9",
	"./partners8.png": "3156",
	"./partners9.png": "e24a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9730";